/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

type CalloutState = 'never_purchased' | 'exhausted';

export const Container = styled(Box, {
  shouldForwardProp: prop => prop !== 'customState',
})<{customState: CalloutState}>(({theme, customState}) => ({
  display: 'flex',
  gap: theme.spacing(2.5),
  padding: theme.spacing(4),
  marginTop: theme.spacing(8),
  borderRadius: theme.spacing(2),
  width: '100%',
  ...(customState === 'never_purchased' && {
    border: `2px dashed ${theme.palette.semantic_dark?.primary.main}`,
  }),
  ...(customState === 'exhausted' && {
    backgroundColor: theme.palette.semantic_dark?.alert.container,
    color: theme.palette.semantic_dark?.alert.onContainer,
  }),
}));

export const Icon = styled(Box, {
  shouldForwardProp: prop => prop !== 'customState',
})<{customState: CalloutState}>(({theme, customState}) => ({
  flexShrink: 0,
  '&.material-symbols-outlined': {
    fontSize: '44px',
    color:
      customState === 'never_purchased'
        ? theme.palette.semantic_dark?.primary.main
        : theme.palette.semantic_dark?.alert.main,
  },
}));

export const Body = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  flex: 1,
}));

export const Title = styled(Box)({
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 500,
});

export const Description = styled(Box)({
  fontSize: '14px',
  lineHeight: '16px',
});
